import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { usePermissions } from "../../../contexts/PermissionsContext";

export default function DeleteModal(props) {
  const { t } = useTranslation();
  const { canExecuteCommand } = usePermissions();
  const [show, setShow] = useState(props.show);

  const handleClose = () => props.handleClose();

  useEffect(() => {
    setShow(canExecuteCommand && props.show);
  }, [canExecuteCommand, props.show]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("COMMON.ATTENTION")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("DELETE_MODAL.CONFIRM_DELETE")} {props.itemName}?</Modal.Body>
        <Modal.Footer>
          <Button variant='warning' onClick={handleClose}>
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            variant='primary'
            disabled={!canExecuteCommand}
            aria-disabled={!canExecuteCommand}
            onClick={() => {
              if (!canExecuteCommand) return;
              handleClose();
              props.callBackRemove(props.itemRemoveId);
            }}>
            {t("DELETE_MODAL.OK")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
